import { render, staticRenderFns } from "./FormAccessLocale.vue?vue&type=template&id=f08dc354&scoped=true&"
import script from "./FormAccessLocale.vue?vue&type=script&lang=js&"
export * from "./FormAccessLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08dc354",
  null
  
)

export default component.exports